<div class="sa-lead-panel__img hero-img">
  <div class="max-auto">
    <div class="sa-lead-panel d-flex align-center plMd prMd" saFitToViewHeight>
      <div class="sa-lead-panel__content" [ngClass]="{'sa-lead-panel__content--show': showContent}">
        <h2 class="h1 sa-lead-panel__text mb20">{{ text }}</h2>
        <button sa-btn (click)="clickMe($event)">{{ actionText }}</button>
      </div>
    </div>
</div>
</div>